export const accreditedLenderBuilderForUI = (data) => {
  return {
    Category: data.Category || '',
    ProviderId: data.ProviderId,
    ProviderName: data.ProviderName,
  };
};
